export default {
  cardId: "Card ID",
  translatedFirst: "Translated first",
  nameOfCard: "Name of card",
  cardText: "Card text",
};
